import { MiButton, MiCheckbox } from "@miplatform/components";
import { BUTTON_VARIANTS } from "@miplatform/constants";
import { MaterialCard } from "../../../../components/MaterialCard/MaterialCard";

export function MaterialResultCard({
  material,
  selectedItems,
  setSelectedItems,
  isSuppliedByBuilder,
  setIsSuppliedByBuilder,
  disabled,
  handleAddItem,
}) {
  const isSelected = selectedItems?.id === material.id;

  const handleCardClick = () => {
    if (isSelected) {
      return;
    }
    if (isSuppliedByBuilder) {
      setIsSuppliedByBuilder(false);
    }
    setSelectedItems(material);
  };

  return (
    <MaterialCard
      key={material.id}
      item={material}
      isSelected={isSelected}
      onClickCard={handleCardClick}
      rightAction={
        isSelected && (
          <>
            <MiCheckbox
              label="Builder Supplied"
              handleChange={(e) => setIsSuppliedByBuilder(e.target.checked)}
              value={isSuppliedByBuilder}
            />
            <MiButton
              title="Add Item"
              onClick={handleAddItem}
              variant={BUTTON_VARIANTS.CONTAINED}
              disabled={disabled}
            />
          </>
        )
      }
    />
  );
}
